import React from "react"
import { Container, Row, Col } from "reusecore/Layout"
import Box from "reusecore/Box"
import Heading from "reusecore/Heading"
import Text from "reusecore/Text"
import Swal from 'sweetalert2'
import { SectionTitle, SectionBackground } from "reusecore/SectionTitle"
import Button from "reusecore/Button"

import AboutSectionWrapper from "./about.style"
import BlogPageWrapper from "../Blog-single/blogSingle.style"
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';

function ReContact({text_contact}) {
  const [name, setName] = React.useState("")
  const [email, setEmail] = React.useState("")
  const [telefono, setTelefono] = React.useState("")
  const [detalle, setDetalle] = React.useState("")
  const [captcha, setCaptcha] = React.useState("")
  const enviar = (e) => {

    if (name === "") {
      
      
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Faltó especificar un nombre',
   
      })
      return null}
    if (email === "") {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Faltó especificar un email',
   
      })
      return null} 
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Email con formáto no válido',
   
      })
      return null}
    if (detalle === "") {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Faltó un mensaje',
   
      })
      return null}
    Swal.showLoading()
    axios.get('https://16d82j2rff.execute-api.sa-east-1.amazonaws.com/Prod/hello', {
      params: {
        nombre: name,
        email: email,
        telefono: telefono,
        mensaje: detalle,
        recaptcha: captcha
      }
    })
    .then(function (response) {
    
      if (response.data.Ok  == "Todo ok!"){
        Swal.hideLoading()
        typeof window !== "undefined" && window.gtag("event", "contact", {
          nombre: name,
          email: email,
          telefono: telefono,
          mensaje: detalle,
          recaptcha: captcha
        })
     
        

        
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Mensaje recibido, te contactaremos.',
          showConfirmButton: false,
          timer: 3500
        })
        e.target.reset();
      }
    else {
      Swal.hideLoading()
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Error en el captcha!',
     
      })
    }

      console.log(response);
    })
    .catch(error => {
      Swal.hideLoading()
      console.log(error)
   })

  }



  function onChange(value) {
    setCaptcha(value)
    console.log("Captcha value:", value);
  }
 
  return (
    <AboutSectionWrapper id="about">
      <Container>
        <Row>
          <Col className="lg-5 md-6 sm-12">
            <BlogPageWrapper>
              <Box className="comment-box-wrapper">
                <SectionTitle>
                  <SectionBackground>
                    <Heading as="h1">
                      Contáctanos
                  </Heading>
                  </SectionBackground>
                </SectionTitle>
                <form onSubmit={(e) => {
                  /**
                   * Prevent submit from reloading the page
                   */
                  e.preventDefault();
                  e.stopPropagation();
                  enviar(e)
                }} >
                  <Box className="form-inline">
                    <input type="text" onChange={(e) => setName(e.target.value)} placeholder="Nombre*" />
                    <input type="email" onChange={(e) => setEmail(e.target.value)} placeholder="Email*" />
                  </Box>
                  <Box className="form-group">
                    <input type="text" onChange={(e) => setTelefono(e.target.value)} placeholder="Teléfono" />
                  </Box>
                  <textarea className="text-area" onChange={(e) => setDetalle(e.target.value)}
                    rows="10"
                    cols="50"
                    placeholder="Mensaje"
                  ></textarea>
                  <ReCAPTCHA 
                  className="captcha"
                  
                    sitekey="6Lep7wMbAAAAAKleBQv9ZOp2njZo7x_YVfQx9R0V"
                    onChange={onChange}
                  />
                  <Button className="button-send" >Enviar</Button>
                </form>
              </Box>
            </BlogPageWrapper>
          </Col>
          <Col className="lg-6 offset-lg-1 md-6 sm-12">
            <Box className="about-right-content">
              <SectionTitle>

                <Heading as="h1">
                  Siéntete en confianza
                  </Heading>


                <Text>

                {text_contact}
                  

                </Text>
              </SectionTitle>

              <Box className="about-list">
                <Text as="span">Ventas y temas comerciales.</Text>
                <Text as="span">Soporte Técnico.</Text>
                <Text as="span">Cuentas y facturación.</Text>
                <Text as="span">Conformidad post venta.</Text>
                <Text as="span">Dudas en general.</Text>
              </Box>


            </Box>
          </Col>
        </Row>
      </Container>
    </AboutSectionWrapper>
  )
}

export default ReContact
